import { render } from "./GreetingPage.vue?vue&type=template&id=33b8b924&scoped=true"
import script from "./GreetingPage.vue?vue&type=script&lang=js"
export * from "./GreetingPage.vue?vue&type=script&lang=js"

import "./GreetingPage.vue?vue&type=style&index=0&id=33b8b924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b8b924"]])

export default __exports__